import { PerformanceDatapoint } from 'owa-analytics';
import LoadingEndState from '../../store/schema/LoadingEndState';
import populateLoadingDataPoint from './populateLoadingDatapoint';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';

/**
 * Handles the end of TXP loading UI and logs loading datapoint
 */
export default function endLoadingPerfDatapointHandler(
    perfDatapoint: PerformanceDatapoint,
    entityNamesMap: number,
    loadingEndState: LoadingEndState,
    txpStatus: TxpStatus,
    isTxpObjectValid: boolean
) {
    const customData: any = populateLoadingDataPoint(
        entityNamesMap,
        loadingEndState,
        txpStatus,
        isTxpObjectValid
    );
    perfDatapoint.addCustomData(customData);
    perfDatapoint.end();
}
